import { MAT_BUTTON_TOGGLE_DEFAULT_OPTIONS } from '@angular/material/button-toggle';
import { MAT_RIPPLE_GLOBAL_OPTIONS } from '@angular/material/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MAT_ICON_DEFAULT_OPTIONS } from '@angular/material/icon';
import { MAT_SELECT_CONFIG } from '@angular/material/select';
import { MAT_SLIDE_TOGGLE_DEFAULT_OPTIONS } from '@angular/material/slide-toggle';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';

export const MAT_FORM_FIELD_CUSTOM_OPTIONS = {
  appearance: 'outline',
  subscriptSizing: 'dynamic',
  color: 'accent',
};

export const MATERIAL_PROVIDERS = [
  { provide: MatDialogRef, useValue: {} },
  { provide: MAT_DIALOG_DATA, useValue: [] },
  { provide: MAT_RIPPLE_GLOBAL_OPTIONS, useValue: { disabled: true } },
  {
    provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
    useValue: MAT_FORM_FIELD_CUSTOM_OPTIONS,
  },
  {
    provide: MAT_SELECT_CONFIG,
    useValue: { hideSingleSelectionIndicator: true },
  },
  {
    provide: MAT_BUTTON_TOGGLE_DEFAULT_OPTIONS,
    useValue: { hideSingleSelectionIndicator: true },
  },
  {
    provide: MAT_SLIDE_TOGGLE_DEFAULT_OPTIONS,
    useValue: { hideIcon: true },
  },
  { provide: MAT_ICON_DEFAULT_OPTIONS, useValue: { fontSet: 'material-icons-round' } },
  {
    provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
    useValue: { duration: 4000, horizontalPosition: 'center', verticalPosition: 'bottom' },
  },
];
